import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  setUser,
  logout,
} from "../slices/authSlice";

export const loginUser = (credentials) => async (dispatch) => {
  try {
    dispatch(loginStart());

    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Login failed");
    }

    // Dispatch login success with user data and token
    dispatch(loginSuccess({
      user: data.user,
      token: data.token
    }));

    // After successful login, fetch additional user data if needed
    dispatch(fetchUserData());

    return data;
  } catch (error) {
    dispatch(loginFailure(error.message));
    throw error;
  }
};

export const registerUser = createAsyncThunk(
  "auth/register",
  async (userData, { dispatch }) => {
    try {
      dispatch(registerStart());

      const response = await fetch("/api/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed");
      }

      dispatch(registerSuccess(data));
      return data;
    } catch (error) {
      dispatch(registerFailure(error.message));
      throw error;
    }
  }
);

export const fetchUserData = () => async (dispatch) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await fetch('/api/protected', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }

    const data = await response.json();
    dispatch(setUser(data.user));
  } catch (error) {
    console.error('Error fetching user data:', error);
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    const response = await fetch('/api/auth/logout', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error('Logout failed');
    }

    dispatch(logout());
  } catch (error) {
    console.error('Logout error:', error);
  }
};
